import React, {Component} from "react";
import {Button, message, Switch ,Input, Radio,Form,Icon,Select,Card,Modal} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import {hasAuth} from "../../../utils/NHCore";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import NHFormItem from '../../common/NHFormItem';
import NHSelect from '../../common/NHSelect/index'
import ModeEditForm from './ModeEditForm.js';
import css from './detail.css'

export default class DockingModeTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
            },
            showOperationBtn: false,
        }
    }

    //选择行后显示删除操作按钮
    rowSelectionChange = selectedRowKeys => {
        this.setState({
            showOperationBtn: selectedRowKeys.length > 0 ? true : false
        });
    };

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name === showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }

    //面板关闭按钮点击事件
    handleFrameClose = () => {
        this.setCurrentPageShow('tableFlag');
        this.refs.nhTable.filterTableData();
    }

    //单行删除
    handleSingleDeleteBtnClick = record => {
        NHConfirm(
            "是否确定删除" + record.ZDMC + "对接参数？",
            () => {
                let pkid = record.DJCSID;
                this.handleDelete([pkid]);
            },
            "warn"
        );
    };
    
    // 多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = [];
        let selectedRows = this.refs.nhTable.state.selectedRows;
        for (let row of selectedRows) {
            selectedRowKeys.push(row.DJCSID);
        }
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm(
                "是否确定删除选中的多个参数？",
                () => {
                    this.handleDelete(selectedRowKeys);
                },
                "warn"
            );
        }
    };

    //删除操作
    handleDelete = pkids => {
        NHFetch(`api/zhxg-jfxt/onPay/deleteByMulti`, 'POST',pkids)
        .then(res => {
            if (res && res.code === 200) {
                NHFetch(`api/zhxg-jfxt/onPay/updatePxh`, 'GET')
                .then(res => {
                    if (res) {
                        message.success("删除参数成功！");
                        this.refs.nhTable.filterTableData();
                    }
                })
            }
        });
    };

    //编辑按钮点击事件
    handleUpdateBtnClick = (record) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        frameVisibleMap['updateFlag'] = true;
        let pkid = record.DJCSID;
        NHFetch(`api/zhxg-jfxt/onPay/${pkid}/getDockingParam`, 'GET')
        .then(res => {
            if (res) {
                this.setState({ 
                    formInitData: res.data,
                    frameVisibleMap: frameVisibleMap 
                });
            }
        })
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        let frameVisibleMap = this.state.frameVisibleMap;
        frameVisibleMap['addFlag'] = true;
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }

    //新增面板保存方法
    handleSaveAdd = () => {
        this.formModelRef.props.form.validateFields((err, values) => {
            if (!err) {
                NHFetch(`api/zhxg-jfxt/onPay/getPxh`, 'POST')
                    .then(res => {
                        if (res) {
                            if (res.data.length !== 0) {
                                let arr = [];
                                for (let i = 0; i < res.data.length; i++) {
                                    arr.push(res.data[i].PXH)
                                }
                                values.pxh = arr.reduce(function (a, b) {
                                    return b > a ? b : a;
                                }) + 1;
                            } else {
                                values.pxh = 1;
                            }
                            values.djfsid=this.props.djfsid;
                            if(!values.zdms){
                                values.zdms="";
                            }
                            if(!values.zdts){
                                values.zdts="";
                            }
                            NHFetch(`api/zhxg-jfxt/onPay/insertDockingParam`, 'POST',values)
                            .then(res => {
                                if (res && res.code === 200) {
                                    message.success("添加基础数据信息成功！");
                                    this.setCurrentPageShow("tableFlag");
                                    this.refs.nhTable.filterTableData();
                                }
                            })
                        }
                    })
            }
        });
    }

    //修改面板保存方法
    handleSaveUpdate = () => {
        this.formModelRef.props.form.validateFields((err, values) => {
            if (!err) {
                values.djcsid=this.state.formInitData.DJCSID;
                values.djfsid=this.props.djfsid;
                NHFetch(`api/zhxg-jfxt/onPay/updateDockingParam`, 'POST',values)
                .then(res => {
                    if (res && res.code === 200) {
                        message.success("修改基础数据信息成功！");
                        this.setCurrentPageShow("tableFlag");
                        this.refs.nhTable.filterTableData();
                    }
                })
            }
          });
    }

    render() {
        const columns = [
            { title: "序号", minWidth: 50, dataIndex: "PXH", fixed: "left" },
            { title: "对接参数ID", minWidth: 150, dataIndex: "DJCSID", fixed: "left" },
            { title: "对接方式ID", minWidth: 150, dataIndex: "DJFSID", fixed: "left" },
            { title: "字段名称", minWidth: 150, dataIndex: "ZDMC", fixed: "left" },
            { title: "字段标志", minWidth: 100, dataIndex: "ZDBZ" },
            { title: "表单控件参数", width: 900, dataIndex: "BDKJCS" },
            { title: "字段描述", width: 100, dataIndex: "ZDMS" },
            { title: "是否必填", width: 100, dataIndex: "SFBT" },
            { title: "字段提示", width: 200, dataIndex: "ZDTS" },
        ];
        //行内操作
        const action = [
            { title: "编辑", onClick: this.handleUpdateBtnClick ,auth: 'zhxg_yxxt_zxjfgl_jffagl:update'},
            { title: "删除", onClick: this.handleSingleDeleteBtnClick ,auth: 'zhxg_yxxt_zxjfgl_jffagl:delete' }
        ];
        return (
            <div style={{height: getSize().windowH - 150}}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>
                    <NHTable
                        ref="nhTable"
                        rowKey={record => record.DJCSID}
                        sign={"zhxg_yxxt_dockingParam_table"}
                        columns={columns}
                        action={action}
                        rowSelectionChange={this.rowSelectionChange}
                        sqlParams={ {djfsid:this.props.djfsid} }
                        baseUrl={`api/zhxg-jfxt`}
                    >
                        {hasAuth("zhxg_yxxt_zxjfgl_jffagl:add") &&
                        <Button type='primary' onClick={this.handleAddBtnClick} style={{ marginRight: 10 }} >添加对接参数</Button>}
                        {hasAuth("zhxg_yxxt_zxjfgl_jffagl:delete") &&
                        <Button type="danger" ghost onClick={this.handleMultiDeleteBtnClick} style={{ marginRight: 10, display: this.state.showOperationBtn ? undefined : "none" }} >  删除 </Button>}
                    </NHTable>
                </div>
                <Modal title="新增对接参数"
                        visible={this.state.frameVisibleMap.addFlag} 
                        onOk={this.handleSaveAdd} 
                        onCancel={this.handleFrameClose}
                        cancelText='取消'
                        okText='确定'>
                    <ModeEditForm key={3} wrappedComponentRef={(form) => (this.formModelRef = form)} />
                </Modal>
                <Modal title="编辑对接参数" 
                        visible={this.state.frameVisibleMap.updateFlag} 
                        onOk={this.handleSaveUpdate}
                        onCancel={this.handleFrameClose}
                        cancelText='取消'
                        okText='确定'>
                    <ModeEditForm key={4} wrappedComponentRef={(form) => (this.formModelRef = form)} editData={this.state.formInitData} />
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/zxjfgl/jffagl/dockingModetable.js